<template>
  <!-- <el-popover placement="top-start" trigger="click">
    <div class="item">
      <span>開啓聲卡優化</span>
      <el-switch v-model="isUseSoundCard" @change="change"> </el-switch>
    </div>
    <el-button class="btn-switch" slot="reference">音质设置</el-button>
  </el-popover> -->
  <div class="item">
    <span>開啓聲卡優化</span>
    <el-switch v-model="isUseSoundCard" @change="change"> </el-switch>
  </div>
</template>
<script>
import VoiceRoomEvent from '@/components/VoiceRoom/voiceRoomEvent';

export default {
  name: 'AnimationSwitch',
  props: {},
  data() {
    return {
      isUseSoundCard:
        localStorage.getItem(VoiceRoomEvent.isUseSoundCard) === 'true'
          ? true
          : false
    };
  },
  watch: {},
  computed: {},
  methods: {
    change($event) {
      this.$confirm({
        content: `刷新网页使设置生效？`,
        confirmButtonText: '確認',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.isUseSoundCard = $event;
          localStorage.setItem(
            VoiceRoomEvent.isUseSoundCard,
            $event ? 'true' : 'false'
          );
          location.reload();
        })
        .catch(() => {
          this.isUseSoundCard = !$event;
        });
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  > span {
    display: inline-block;
    margin-right: 5px;
  }
}
</style>
